import { Case, getCaseApiUrl } from '@/api/apis/case';
import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import {
  OrganAcceptanceCriteriaFields,
  OrganAcceptanceCriteriaFieldsTemplate,
  OrganAcceptanceCriteriaTemplate,
} from '@/api/apis/cases';

const createCaseOrganAcceptanceCriteria = async (caseId: string, data: OrganAcceptanceCriteriaFields) => {
  const res = await http.post<ApiResponseBody<Case>>(getCaseApiUrl.caseOrganAcceptanceCriteria(caseId), data);
  return res.data.data;
};

const getOrganAcceptanceCriteriaTemplate = async (params: {
  txCenterId: string;
}): Promise<OrganAcceptanceCriteriaTemplate[]> => {
  const res = await http.get<ApiResponseBody<OrganAcceptanceCriteriaTemplate[]>>(
    getCaseApiUrl.getOrganAcceptanceCriteriaTemplate(),
    { params },
  );
  return res.data.data ?? {};
};

const createOrganAcceptanceCriteriaTemplate = async (data: OrganAcceptanceCriteriaFieldsTemplate) => {
  const res = await http.post<ApiResponseBody<OrganAcceptanceCriteriaTemplate>>(
    getCaseApiUrl.createOrganAcceptanceCriteriaTemplate(),
    data,
  );
  return res.data.data;
};

const updateOrganAcceptanceCriteriaTemplate = async (templateId: string, data: OrganAcceptanceCriteriaFields) => {
  const res = await http.patch<ApiResponseBody<OrganAcceptanceCriteriaTemplate>>(
    getCaseApiUrl.updateOrganAcceptanceCriteriaTemplate(templateId),
    data,
  );
  return res.data.data;
};

export const organAcceptanceCriteriaFetcher = {
  getOrganAcceptanceCriteriaTemplate,
  createCaseOrganAcceptanceCriteria,
  createOrganAcceptanceCriteriaTemplate,
  updateOrganAcceptanceCriteriaTemplate,
};
